const cache = {};

const getKey = ( cachePrefix, key ) => {
    return `${ cachePrefix }:${ key }`;
};

const get = ( key ) => {
	const hit = cache[ key ];

	if ( hit ) {
		return hit.value;
	}
};

const set = ( key, value, lifetimeMins ) => {
	// if key already exists, cancel its already-running timeout
	const hit = cache[ key ];
	if ( hit && hit.timeout !== undefined ) {
		clearTimeout( hit.timeout );
	}

	// set cache value
	cache[ key ] = {
		value,
		timeout: !isNaN( lifetimeMins )
			// 1000 * 60 * lifetimeMins = 1 minute
			// this sets the cache to 5 minutes
			? setTimeout( () => delete cache[ key ], 1000 * 60 * lifetimeMins * 5 )
			: undefined
	};

	return value;
};

const remove = ( key ) => {
	const hit = cache[ key ];

	if ( hit ) {
		// remove timeout before removing cache
		if ( hit.timeout !== undefined ) {
			clearTimeout( hit.timeout );
		}
		delete cache[ key ];
	}
};

const clear = () => {
	// remove timeouts & cache
	Object.keys( cache ).forEach( key => {
		remove( key );
	} );
};

const clearByKey = ( key ) => {
    remove( key );
};

const clearByKeyStartsWith = ( partialKey ) => {
    Object.keys( cache ).forEach( key => {
        if ( key.startsWith( partialKey ) ) {
            remove( key );
        }
    } );
};

export default {
    getKey,
	get,
	set,
	remove,
    clear,
    clearByKey,
    clearByKeyStartsWith
};
